import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import SidebarMenuNavigation from './SidebarMenuNavigation';
import AuthNavigation from './AuthNavigation';
import AccountSetupAndSettingsMainNavigation from './AccountSetupAndSettingsMainNavigation';
import HospitalitySidebarMenuNavigation from './HospitalitySidebarMenuNavigation';
import AccountSetupWizardNavigation from './AccountSetupWizardNavigation';

const Navigation = () => {
  const businessType = sessionStorage.getItem('businessType');
  const setting = sessionStorage.getItem('setting');
  return (
    <>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <Routes>
          {AuthNavigation}
          {businessType === 'Retail' ? SidebarMenuNavigation : HospitalitySidebarMenuNavigation}

          {AccountSetupAndSettingsMainNavigation}
          {setting === 'finished' ? (
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          ) : (
            AccountSetupWizardNavigation
          )}
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default Navigation;
